import { useState } from 'react';
import { User } from 'lucide-react';

interface AvatarProps {
  name: string;
  avatarUrl: string | null;
  size?: 20 | 24 | 28 | 32;
  className?: string;
}

const SIZE_CLASS: Record<NonNullable<AvatarProps['size']>, string> = {
  20: 'h-5 w-5 text-[9px]',
  24: 'h-6 w-6 text-[10px]',
  28: 'h-7 w-7 text-xs',
  32: 'h-8 w-8 text-sm',
};

const ICON_SIZE: Record<NonNullable<AvatarProps['size']>, string> = {
  20: 'h-3 w-3',
  24: 'h-3.5 w-3.5',
  28: 'h-4 w-4',
  32: 'h-4 w-4',
};

export function Avatar({ name, avatarUrl, size = 28, className }: AvatarProps) {
  const [imgErrored, setImgErrored] = useState(false);
  const trimmed = name.trim();
  const showImg = avatarUrl && !imgErrored;
  const initial = trimmed ? trimmed[0]!.toUpperCase() : null;

  const base =
    'inline-flex items-center justify-center rounded-full overflow-hidden bg-brand-100 text-brand-700 font-semibold select-none';
  const cls = [base, SIZE_CLASS[size], className].filter(Boolean).join(' ');

  return (
    <span className={cls} aria-hidden="true">
      {showImg ? (
        <img
          src={avatarUrl}
          alt=""
          className="h-full w-full object-cover"
          onError={() => setImgErrored(true)}
          referrerPolicy="no-referrer"
        />
      ) : initial ? (
        <span>{initial}</span>
      ) : (
        <User className={ICON_SIZE[size]} />
      )}
    </span>
  );
}
